import {Provider} from 'react-redux';
import {getStore} from '@app/store';
import {AppRouter} from '@app/router/AppRouter';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {ErrorBoundary} from './ErrorBoundary';
import {MsalProvider} from '@azure/msal-react';
import {msalInstance} from '@app/utils/msalClient';
import {useEffect, useState} from 'react';
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import {TOKEN_EXPIRY_TIME, USER_ID} from '@app/common/constants';
import {saveAccessToken, saveMsalAccount} from '@app/helper/login';
import {Box, CircularProgress} from '@mui/material';


export const store = getStore();

export const themeOptions: any = {
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 800,
          color: '#322b7c',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
          fontWeight: '600',
          fontStyle: 'normal',
          letterSpacing: 0,
          textAlign: 'center',
          fontSize: 12.7,
        },
      },
    },
  },
  typography: {
    fontFamily: ['Poppins'].join(','),
    fontSize: 13,
    leftSideBar: {
      color: '#534e91',
    },
    rightSideBar: {
      color: '#534e91',
    },
  },
  backgroundColors: {
    leftSidebar: '#f5f8f9',
  },
  palette: {
    primary: {
      main: '#322b7c',
    },
    title: {main: '#322b7c'},
    white: {
      main: '#ffffff',
    },

  },
 
};
export const DialogProps = { 
  sx: {
 marginLeft:'22px !important'
  },

};
// Loading component that can be reused
const AppLoader = () => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    height="100vh"
    sx={{ backgroundColor: '#f5f8f9' }}
  >
    <CircularProgress sx={{ color: '#322b7c' }} size={50} />
  </Box>
);

const theme = createTheme(themeOptions);

function App() {
  const [msalInitialized, setMsalInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        
        // Handle MSAL redirect if present
        const response = await msalInstance.handleRedirectPromise();
        
        if (response && response.account) {
          // Save MSAL token immediately
          const token = response.idToken || response.accessToken;
          if (token) {
            const decoded: any = jwt_decode(token);
            saveAccessToken(token);
            saveMsalAccount(JSON.stringify(response.account));
            localStorage.setItem(TOKEN_EXPIRY_TIME, JSON.stringify(decoded.exp));
            localStorage.setItem(USER_ID, decoded.nbf);
            localStorage.setItem('AUTH_TYPE', 'MSAL');
          }
        }
        
        setMsalInitialized(true);
      } catch (error) {
        console.error('MSAL initialization error:', error);
        setMsalInitialized(true);
      }
    };
    
    initializeMsal();
  }, []);

  if (!msalInitialized) {
    return <AppLoader />;
  }

  return (
    <ErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <AppRouter />
          </ThemeProvider>
        </Provider>
      </MsalProvider>
    </ErrorBoundary>
  );
}

export default App;